module.exports = __webpack_public_path__ + "img/logo-4.0a4e2311.png";